import {
  PaginatedItemsAction,
  PaginatedItemsActions,
  PaginatedItemState,
} from 'context/PaginatedItems/types/PaginatedItems';

export const defaultPaginatedItemState = {
  items: [],
  totalElements: 0,
  page: 0,
  totalPages: 0,
};

export const paginatedItemsReducer = <T>(
  state: PaginatedItemState<T>,
  action: PaginatedItemsAction<T>
): PaginatedItemState<T> => {
  switch (action.type) {
    case PaginatedItemsActions.InitialLoad:
      return {
        items: action.payload.items,
        totalElements: action.payload.totalElements,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
      };

    case PaginatedItemsActions.LoadMore:
      return {
        items: [...state.items, ...action.payload.items],
        totalElements: action.payload.totalElements,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
      };
    default:
      return state;
  }
};
